var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgMap = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2 3.00003H20.5C20.7761 3.00003 21 3.22388 21 3.50003V18.33C21.002 18.7374 20.7568 19.1052 20.38 19.26L16.75 20.77C16.3855 20.9216 15.9947 20.9998 15.6 21H14.4C14.0053 20.9998 13.6145 20.9216 13.25 20.77L9 19L4.57 20.85C4.32575 20.9504 4.06405 21.0013 3.8 21H3.5C3.22386 21 3 20.7762 3 20.5V5.67003C2.99796 5.26268 3.24321 4.89481 3.62 4.74003L7.25 3.23003C7.61447 3.07845 8.00527 3.00029 8.4 3.00003H9.6C9.99473 3.00029 10.3855 3.07845 10.75 3.23003L15 5.00003L19.43 3.15003C19.6742 3.04968 19.9359 2.9987 20.2 3.00003ZM9.77 17.15L14 18.92C14.1264 18.9739 14.2626 19.0011 14.4 19H15V7.17002L14.23 6.85003L9.98 5.08002C9.85978 5.02878 9.73068 5.00161 9.6 5.00003H9V16.83L9.77 17.15Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMap, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/map.04925423.svg";
export { ForwardRef as ReactComponent };